<template lang="pug">
#company-detail(v-if="company")
  section#banner.bg-cover.relative
    div#preview.image.hidden-xs(':style'="company.cover_image | resource | bgImage previewStyle")
    img.visible-xs(':src'="company.cover_image | resource")
    //a.prev(v-link="pagination.prev | companyDetailUrl category | slug", v-if="pagination.prev")
      span.fa-stack
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-arrow-left.fa-stack-1x.fa-inverse
    //a.next(v-link="pagination.next | companyDetailUrl category | slug", v-if="pagination.next")
      span.fa-stack
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-arrow-right.fa-stack-1x.fa-inverse
  section
    .sm-container
      .row
        .col-sm-6.row
          .name(v-if="company.name | multilang") {{company.name | multilang}}
          .desc(v-if="company.description | multilang") {{{company.description | multilang}}}
          .link
            a(':href'="company.link.website" v-if="company.link.website" target="_blank")
              span.fa-stack
                i.fa.fa-globe.fa-2x
            a(':href'="company.link.facebook" v-if="company.link.facebook" target="_blank")
              span.fa-stack
                i.fa.fa-circle.fa-stack-2x
                i.fa.fa-facebook.fa-stack-1x.fa-inverse
            a(':href'="company.link.linkedin" v-if="company.link.linkedin" target="_blank")
              span.fa-stack
                i.fa.fa-circle.fa-stack-2x
                i.fa.fa-linkedin.fa-stack-1x.fa-inverse
            a(':href'="company.link.twitter" v-if="company.link.twitter" target="_blank")
              span.fa-stack
                i.fa.fa-circle.fa-stack-2x
                i.fa.fa-twitter.fa-stack-1x.fa-inverse

        .col-sm-offset-1.col-sm-5.row
          .share.text-right
            //- p {{'SHARE' | wordDict}}
            //-   |

          .info-wrap(v-if="company.project_date")
            h4 {{'SR_COMPANY_DATE' | wordDict}}
            p {{company.project_date | moment 'L'}}

          .info-wrap(v-if="company.leadership | multilang")
            h4 {{'SR_COMPANY_PARTNER' | wordDict}}
            p {{company.leadership | multilang}}

          .info-wrap(v-if="company.media && company.media.length")
            h4 {{'COMPANY_MEDIA' | wordDict}}
            div(v-for="media in company.media", track-by="$index")
              p
                a(v-link="media.url", target="_blank") {{media.name | multilang}}
          
  back-button(':title'="'BACK_TO_SR' | wordDict", ':path'="path")
</template>

<script>
import axios from 'axios'
import BackButton from './../../back-button.vue'


export default {
  data () {
    return {
      companies: [],
      company: { link:{} },
      pagination: { prev:null, next:null },
      previewStyle: { height: `${Math.round(window.innerHeight * .8)}px`, },
    }
  },
  computed: {
    path () { return '/about/social-responsibility-projects' },
    company_id() {
      return this.$route.params.id.toUpperCase()
    },
  },
  ready() {
  },
  created () {
    axios.get(`/api/social_companies`)
      .then((res) => {
        this.companies = res.data.results
        this.updateCompany(this.$route.params.id)
      })
      .catch(function (error) {
        alert(error)
        console.log(error)
      })
  },
  route: {
    data: function (transition) {
      let params = transition.to.params
      this.updateCompany(params.id)
      // redirect to url with slug
      if (!params.slug) {
        window.location.pathname = this.$options.filters.socialCompanyDetailUrl(this.company, this.category)
      }
    },
  },
  methods: {
    updateCompany(companyId) {
      let index = _.findIndex(this.companies, {company_id: companyId.toUpperCase()})
      this.company = this.companies[index]
      // this.pagination = {
      //   prev: this.companies[index-1],
      //   next: this.companies[index+1],
      // }
    },
  },
  components: {
    BackButton
  }
}
</script>

<style lang="scss" scoped>
@import "global";

@media (max-width: $grid-float-breakpoint-max) {
  section:not(#banner) {
    padding: 16px;
    &:not(:first-child) {
      padding-top: 0;
    }
    &:last-child {
      padding-bottom: 16px;
    }
  }
  .sm-container {
    text-align: center;
  }
}

.sm-container {
  max-width: 1000px;
}

#banner {
  @media (max-width: $grid-float-breakpoint-max) {
    margin-bottom: 28px;
  }
  .image {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-attachment: fixed;
    height: 80vh;

    @media(max-width: $grid-float-breakpoint-max) {
      background-size: contain;
      padding-bottom: 50%;
    }
  }
  padding-top: 0;
  padding-bottom: 0;
  img {
    width: 100%;
  }
  // max-height: 900px;
  // overflow: hidden;
  // height: 500px;
  > a {
    position: absolute;
    top: 50%;
    color: rgba(#000, 0.8);
    &.prev {
      left: 30px;
    }
    &.next {
      right: 30px;
    }
  }
}

.name {
  color: #000;
  font-size: 28px;
  font-weight: bold;
  text-transform: uppercase;
  text-align: left;
  margin-bottom: 14px;
  @media (max-width:$grid-float-breakpoint-max) {
    font-size: 22px;
    margin-bottom: 24px;
  }
}

.desc {
  color: #404047;
  margin-bottom: 24px;
  text-align: left;
}

.link {
  margin-bottom: 24px;
  a {
    color: $text-color;
  }
  .fa-stack {
    color: #000;
    font-size: 16px;
    width: 42px;
    text-align: center;
  }
}

.info-wrap {
  margin-bottom: 24px;
  > h4 {
    text-transform: uppercase;
    font-weight: bold;
    margin: 12px 0;
  }
  > p {
    color: #404047;
  }
  span {
    display: inline-block;
    &:not(:first-child) { margin-left: 5px; }
    &:not(:last-child) { margin-right: 5px; }
  }
  @media (max-width:$grid-float-breakpoint-max) {
    &:first-child {
      margin-top: 4px;
    }
  }
}

#back-btn {
  margin-left: -30px;
}
</style>



// WEBPACK FOOTER //
// company-detail.vue?61b2ce10